import React from 'react';
import { useDispatch } from 'react-redux';
import { ONBOARD_ERROR } from '../../form-store/action-types';

const Alert = ({ show, message }) => {
    const dispatch = useDispatch();

  return (
    show && (
      <div className={`sisp-alert`}>
        <svg
          width='26'
          height='26'
          viewBox='0 0 26 26'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <g filter='url(#filter0_d)'>
            <circle cx='13' cy='9' r='8' stroke='white' strokeWidth='2' />
          </g>
          <line
            x1='8.2286'
            y1='14.3637'
            x2='17.3027'
            y2='3.36365'
            stroke='white'
            strokeWidth='2'
          />
          <defs>
            <filter
              id='filter0_d'
              x='0'
              y='0'
              width='26'
              height='26'
              filterUnits='userSpaceOnUse'
              colorInterpolationFilters='sRGB'
            >
              <feFlood floodOpacity='0' result='BackgroundImageFix' />
              <feColorMatrix
                in='SourceAlpha'
                type='matrix'
                values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
              />
              <feOffset dy='4' />
              <feGaussianBlur stdDeviation='2' />
              <feColorMatrix
                type='matrix'
                values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0'
              />
              <feBlend
                mode='normal'
                in2='BackgroundImageFix'
                result='effect1_dropShadow'
              />
              <feBlend
                mode='normal'
                in='SourceGraphic'
                in2='effect1_dropShadow'
                result='shape'
              />
            </filter>
          </defs>
        </svg>
        <span>{message}</span>
        <span
          className='close'
          onClick={() => dispatch({ type: ONBOARD_ERROR, payload: false })}
        >
          &times;
        </span>
      </div>
    )
  );
};

export default Alert;
